const mutations = {
    SET_ERROR_LOGISTIC_CONFIGURATION(state, payload) {
        state.error = payload;
    }
};

export default mutations;
